import React, { useEffect, useState } from "react";
import { Landmark, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";

const cls = "w-full px-3 py-2.5 bg-black/40 border border-white/10 focus:border-[#d4a017] outline-none text-sm text-white rounded-sm disabled:opacity-60";
const FIELDS = [["legal_name", "Legal company name", 2], ["entity_type", "Entity type", 1], ["ein", "EIN", 1], ["address", "Street address", 2],
  ["city_state_zip", "City, state, ZIP", 2], ["phone", "Phone", 1], ["email", "Email", 1], ["managing_member", "Managing member", 2]];

/** Super admin: the legal for-profit entity + payment details printed in "Remit Payment To" on every invoice PDF. */
export const RemitToTab = () => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    apiClient.get("/platform-settings/remit-to").then(({ data }) => live && setF((p) => p || data)).catch((e) => toast.error(formatApiError(e)));
    return () => { live = false; };
  }, []);
  if (!f) return <Loader2 className="h-4 w-4 animate-spin text-nex-muted" />;
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await apiClient.put("/platform-settings/remit-to", f); setF(data); toast.success("Remit-to details saved. New invoice PDFs use them right away."); }
    catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  const ro = !f.can_edit;
  return (
    <form onSubmit={save} data-testid="remit-to-card" className="card-industrial corner-tick p-6 md:p-8 max-w-3xl">
      <div className="flex items-center gap-3 mb-2"><Landmark className="text-nex-gold" size={20} /><div className="mono-label">// INVOICE REMIT-TO</div></div>
      <p className="text-nex-chrome text-sm mb-6">The legal entity and payment details printed under "The Exchange Alliance" and in "Remit Payment To" on every invoice PDF.{ro && " Only super admins can change these."}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, label, span]) => (
          <label key={k} className={span === 2 ? "sm:col-span-2" : ""}>
            <span className="block font-mono text-[10px] uppercase tracking-wider text-nex-muted mb-1">{label}</span>
            <input data-testid={`remit-${k}`} className={cls} value={f[k] || ""} onChange={set(k)} disabled={ro} required={k === "legal_name"} />
          </label>
        ))}
        <label className="sm:col-span-2">
          <span className="block font-mono text-[10px] uppercase tracking-wider text-nex-muted mb-1">Payment instructions</span>
          <textarea data-testid="remit-instructions" rows={3} className={cls} value={f.instructions || ""} onChange={set("instructions")} disabled={ro} />
        </label>
      </div>
      {!ro && <button data-testid="remit-save" type="submit" disabled={busy} className="tick-btn-primary mt-6 inline-flex items-center gap-2 disabled:opacity-50">
        {busy && <Loader2 size={14} className="animate-spin" />} Save remit-to details</button>}
    </form>
  );
};
